import { render, staticRenderFns } from "./SparepartMutation.vue?vue&type=template&id=25884d72&scoped=true&"
import script from "./SparepartMutation.vue?vue&type=script&lang=js&"
export * from "./SparepartMutation.vue?vue&type=script&lang=js&"
import style0 from "./SparepartMutation.vue?vue&type=style&index=0&id=25884d72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25884d72",
  null
  
)

export default component.exports